// extracted by mini-css-extract-plugin
export default {"title":"PageHeader_title__YDhmh","center":"PageHeader_center__Gg+bj","linkBack":"PageHeader_linkBack__5G3qY","linkBackText":"PageHeader_linkBackText__wc9Xt"};